// extracted by mini-css-extract-plugin
module.exports = {"link":"DropdownLink_link__1Obd0","disabled":"DropdownLink_disabled__2Qvv7","icon":"DropdownLink_icon__1PuiB"};